import { AxiosError } from 'axios';
import { Dispatch } from 'redux';
import { AppThunk } from 'store';

import { DiscountApi } from '../api/discount.api';
import {
  fetchDeleteDiscounts,
  fetchDiscountFailed,
  fetchDiscountSuccedded,
} from '../slices/discount.slice';

export const deleteDiscountRequest = (
  id: string,
  onError: (err?: AxiosError | { message: string; statusCode: string }) => void,
): AppThunk => async (dispatch: Dispatch<any>) => {
  dispatch(fetchDeleteDiscounts());

  try {
    await DiscountApi.deleteDiscount(id);
  } catch (err) {
    const { name, response: responseError, stack, isAxiosError } = err;
    if (responseError?.data) {
      const {
        data: { statusCode, message },
      } = responseError;
      // - Fetch failed, set error
      dispatch(
        fetchDiscountFailed({
          key: 'delete',
          error: {
            isAxiosError,
            message,
            name,
            code: statusCode,
            stack,
          },
        }),
      );
      onError(err);
      return;
    }
    dispatch(
      fetchDiscountFailed({
        key: 'delete',
        error: {
          isAxiosError,
          message: '',
          name: '',
          code: '404',
          stack: '',
        },
      }),
    );
    onError(err);
    return;
  }

  dispatch(fetchDiscountSuccedded({ key: 'delete', id }));
  onError(undefined);
  return;
};
